// extracted by mini-css-extract-plugin
export default {"section-container":"ContentContainer_section-container__+Pz+k"};